import { SmoothScrollTo } from "@public/js/components/smothScrollTo.js";
import { Directive } from "vue";

export type AppSmoothScrollToElement = HTMLLinkElement & {
    _appSmoothScrollTo?: SmoothScrollTo;
};

export const appSmoothScrollToDirective: Directive<AppSmoothScrollToElement> = {
    mounted(el) {
        el._appSmoothScrollTo = new SmoothScrollTo(el);
    },
    unmounted(el) {
        el._appSmoothScrollTo?.destroy(el);
    },
    updated(el) {
        el._appSmoothScrollTo?.update(el);
    },
};
